import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';
import NumberFormatter from '../../NumberFormatter';
import ReportQuery from './ReportQuery';

export default class EarlyPayment extends React.Component {

    constructor(props) {

        super(props);

        this.nodes = {
            element: null,
        };
    }

    static get propTypes() {

        return {
            payment: PropTypes.instanceOf(NumberFormatter),
            description: PropTypes.string,
            details: PropTypes.object,
            report: PropTypes.instanceOf(ReportQuery)
        };
    }
    
    render() {
        
        return (
            <div
                className={ style('flex flex-wrap gap w-full border-bottom border-bottom:no-last-child pb-8') }
                ref={ (node) => { this.nodes.element = node; } }>
                
                    {/* payment and close button */}
                    <div className={ style('flex w-full justify-between items-center') }>
                        <div className={ style('title3') }>{ this.props.payment.formatted() }</div>
                        <i
                            className={ style('text-primary icon-close cursor-pointer title3') }
                            onClick={ () => this.remove() }
                            />
                    </div>

                    {/* early payment type */}
                    <div className={ style('w-full text-medium') }>{ this.props.description }</div>

                    {/* early payment details */}
                    <div className={ style('flex-grid-2 w-full') }>
                        { this.renderDetails() }
                    </div>

            </div>
        );
    }

    renderDetails() {

        return Object
            .entries(this.props.details)
            .map(([label, value], index) => this.renderDetail(label, value, index));
    }

    renderDetail(label, value, index) {

        return (
            <div className={ style('flex flex-wrap mobile:grid-2 w-full gap') } key={ `detail${index}` }>
                <div className={ style('text-medium text-muted') }>{ label }</div>
                <div className={ style('text-medium mobile:text-right') }>{ value }</div>
            </div>
        );
    }

    remove() {

        this.props.report.removeEarlyPayment({ nonce: this.props.nonce });

        this.nodes.element.closest('form').dispatchEvent(new Event('submit'));
    }
}